<template>
  <div class="index">
    <div class="bottom">
      <div class="index-con bottom-con">
        <div class="footer-left">
          <div>
            <img style="margin-right: 10px" src="../../static/jiang.png" height="120px" />
            <!-- <img src="http://mk.chinaman.cn/mybigdatas/ids/static/logoids.png" height="120px" /> -->
          </div>
        </div>
        <div class="footer-right">
          <!-- <img src="../../static/footer-text.png" alt=""> -->
          <p>{{ $t("headerTitle") }}</p>
          <p>{{ $t("headerTitle1") }}</p>
        </div>
        <div class="bottom-right">
          <!-- <p> {{ $t("footReserved") }}</p>
          <p> {{ $t("footSymposium") }}</p>
          <p> {{ $t('footText1') }}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  onload() { },
  mounted() { },
  methods: {
    toOther(url) {
      this.$router.push("/" + url);
    },
  },
};
</script>

<style scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
}

.index {
  width: 100%;
}

.bottom {
  border-top: 4px solid green;
  background: #efefef;
  padding: 20px 0;
}

.bottom-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-con p {
  color: #333;
  text-align: right;
}

.footer-left {
  display: flex;
  text-align: left;
  align-items: center;
}

.footer-right {
  margin-left: 20px;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  height: 120px;
  /* align-items: end; */
}

.footer-right img {
  height: 120px;
}

.footer-right p {
  text-align: left;
  font-size: 30px;
  font-family: "LiSu";
  color: #333;
  text-shadow: 2px 2px 2px #999;
}

.footer-right p:nth-of-type(2) {
  font-size: 20px;
  margin-top: 10px;
}

.footer-title b {
  font-size: 22px;
  font-family: "LiSu";
}

.footer-text {
  width: 100%;
  display: flex;
  font-family: "Hiragino Sans GB";
  justify-content: space-between;
}

.footer-text span {
  font-size: 18px;
  text-align: left;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .footer-right,
  .footer-left {
    display: block;
  }

  .bottom-con {
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue